// One place mapping every ErrorCode the server can send to a sentence a player understands — the lobby
// and the connection module both show these, so neither has to invent its own wording. The server sends
// only the code; the sentence is the viewer's language (i18n error.*).
import type { ErrorCode } from '../../shared/protocol.js';
import { t, tMaybe, type MsgKey } from '../i18n/index.js';

// Compile-time: every ErrorCode has its sentence in the dictionaries.
const ALL_CODES_WORDED: `error.${ErrorCode}` extends MsgKey ? true : never = true;
void ALL_CODES_WORDED;

/** A code this build does not know (a newer server) still reads as a generic server error. */
export function errorText(code: ErrorCode): string {
  return tMaybe(`error.${code}`) ?? t('error.unknown', { code });
}
